import type { ReactNode } from 'react';
import { Alert } from '~/components/ui/Alert';

const DomainInfoAlert = ({ title, children }: { title: string; children?: ReactNode }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="font-semibold text-sm text-bolt-ds-textPrimary">{title}</div>
      <div className="text-bolt-ds-textSecondary text-sm">{children}</div>
    </div>
  );
};

export const DomainRegisteredStatus = ({ domain }: { domain: string }) => {
  return (
    <DomainInfoAlert title={`We have confirmed that ${domain} is registered`}>
      We are ready to add it to your project. Click "Add domain" and we will guide you through the DNS configuration
      step.
    </DomainInfoAlert>
  );
};

export const DomainNotRegisteredStatus = ({ domain }: { domain: string }) => {
  return (
    <DomainInfoAlert title={`${domain} is not registered yet.`}>
      If you'd like to use this domain as your own, select "Buy this domain" below.
    </DomainInfoAlert>
  );
};

export const DomainUnknownStatus = () => {
  return (
    <Alert type="danger" title="We couldn't verify the domain status.">
      Please try again.
    </Alert>
  );
};

export const DomainConflictStatus = () => {
  // TODO we should link to a support page on how to resolve this

  return (
    <DomainInfoAlert title="Another project is already using this domain">
      Domains must be unique across all projects. Currently another project is using this domain. If you don't know
      which project, please contact support for guidance.
    </DomainInfoAlert>
  );
};
